import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";

export const theme = createTheme({
  typography: {
    h4: {
      fontSize: "clamp(1.4rem, 4.5vw, 2.25rem)",
    },
    h5: {
      fontSize: "clamp(1.2rem, 3.5vw, 1.875rem)",
    },
    h6: {
      fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
    },
    body1: {
      fontSize: "clamp(0.775rem, 4vw, 1rem)",
    },
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: "clamp(8px, 4vw, 16px)",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            width: "clamp(0.7em, 4vw, 1em)",
            height: "clamp(0.7em, 4vw, 1em)",
          },
        },
      },
    },
  },
});
